<template>
    <div class="content-container" v-if="contentPreview">
      <h4 class="preview-header"><img class="preview-icon" src="../../assets/icons/preview.png">Content Preview</h4>

      <div class="action-container">
        <p class="preview-text">You are currently viewing pending content changes for {{ siteName }}. This preview may differ from the live site.</p>
        <button @click="clearPreviewMode()" class="return-button">Exit Preview Mode</button>
      </div>
    </div>
</template>

<script>

export default {
  name: 'ContentPreview',
  components: {
  },
  data () {
    return {
      siteName: '',
      contentPreview: false
    }
  },
  created () {
    this.parseQueryParams()
    this.loadContentPreview()
  },
  methods: {
    clearPreviewMode () {
      this.clearPreviewQueryParam()
      localStorage.contentPreview = false
    },
    loadContentPreview () {
      this.siteName = document.location.hostname
      if (localStorage.contentPreview) {
        try {
          this.contentPreview = JSON.parse(localStorage.contentPreview)
        } catch (e) {
          console.log(`Failed to parse contentPreview (defaulting to false): ${e}`)
        }
      }
    },
    parseQueryParams () {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('contentPreview')) {
        localStorage.contentPreview = urlParams.get('contentPreview')
      }
    },
    clearPreviewQueryParam () {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('contentPreview')) {
        urlParams.delete('contentPreview')
        window.location.search = urlParams
      } else {
        location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .content-container {
    position: sticky;
    bottom: 20px;
    left: 20px;
    width: 300px;
    background: #ffd067;
    padding: 10px;
    border-radius: 10px;
    z-index: 99;
  }

  .content-container:hover {
    .action-container {
      display: block;
    }
  }

  .preview-header {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: black;
  }

  .preview-icon {
    width: 40px;
    margin-right: 15px;
  }

  .preview-text {
    margin-top: 20px;
    padding: 0 15px;
  }

  .return-button{
    width: fit-content;
    background-color: #007bbd;
    border-radius: 10px;
    padding: 5px 10px;
    margin: auto;
    color: white;
    display: block;
  }

  .action-container {
    position: relative;
    display: none;
  }

</style>
